// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// WAŻNE: Wklej tutaj obiekt firebaseConfig, który skopiowałeś w punkcie 4!
const firebaseConfig = {
  apiKey: "AIzaSyAjXm0KJeKTajjj5EcpooZ_6vll43dYCN8",
  authDomain: "portfolio-mama-kalendarz.firebaseapp.com",
  projectId: "portfolio-mama-kalendarz",
  storageBucket: "portfolio-mama-kalendarz.firebasestorage.app",
  messagingSenderId: "814695160731",
  appId: "1:814695160731:web:086f591fea5cc991f8df3e"
};

// Inicjalizacja aplikacji Firebase
const app = initializeApp(firebaseConfig);

// Eksportowanie usług, których będziemy używać w innych częściach aplikacji
export const db = getFirestore(app);
export const auth = getAuth(app);